import type { ReactNode } from 'react'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@ds/components'

import styles from './AudioAdditionalInfo.module.css'

type TAudioAdditionalInfoProps = {
    activeTab: string
    onTabChange: (tab: string) => void
    detailsLabel: string
    commentsLabel: string
    detailsSlot: ReactNode
    commentsSlot: ReactNode
}

// Details | Comments tabs. Both panels `forceMount` so the details (SEO) content and the comments
// thread stay in the DOM across tab switches (parity with the nextjs page).
export const AudioAdditionalInfo = ({
    activeTab,
    onTabChange,
    detailsLabel,
    commentsLabel,
    detailsSlot,
    commentsSlot,
}: TAudioAdditionalInfoProps) => (
    <Tabs value={activeTab} onValueChange={onTabChange}>
        <TabsList className={styles.list}>
            <TabsTrigger value="details">{detailsLabel}</TabsTrigger>
            <TabsTrigger value="comments" data-test="audio-comments-tab">
                {commentsLabel}
            </TabsTrigger>
        </TabsList>
        <TabsContent value="details" forceMount className={styles.content}>
            {detailsSlot}
        </TabsContent>
        <TabsContent value="comments" forceMount className={styles.content}>
            <div className={styles.commentsLayout}>{commentsSlot}</div>
        </TabsContent>
    </Tabs>
)
